import { styled } from 'stitches.config'
import { Stack } from 'components/Stack'

export const FooterMessageRoot = styled('div', {
  paddingLeft: '24px',
  paddingRight: '24px',
  paddingBottom: '40px',
  margin: 'auto',

  '& strong': {
    fontWeight: '$semiBold',
  },

  '@bp2': {
    paddingLeft: '120px',
    paddingRight: '120px',
    paddingBottom: '102px',
    '& .m-only': {
      display: 'none',
    },
    '& .d-only': {
      display: 'block',
    },
  },
})

export const Title = styled('h2', {
  fontFamily: '$display',
  fontWeight: '$light',
  color: '$accent-black',
  fontSize: '$h3',
  letterSpacing: '$h3',
  lineHeight: '$h3',
  margin: 0,
  marginBottom: '6px',
  width: '100%',

  '@bp2': {
    fontSize: '$h2',
    letterSpacing: '$h2',
    lineHeight: '$h2',
  },
})

export const ImageWrapper = styled('div', {
  display: 'none',

  '@bp2': {
    display: 'block',
    position: 'relative',
    maxWidth: '345px',
    width: '200px',
    height: '192px',
    flexShrink: 0,
    borderRadius: '8px 0px 0px 8px',
    overflow: 'hidden',

    '& img': {
      objectPosition: 'center',
    },
  },

  variants: {
    step: {
      '1': {
        '& img': {
          objectPosition: '50% 10%',
        },
      },
      '2': {
        '& img': {
          objectPosition: '50% 10%',
        },
      },
      '3': {
        '& img': {
          objectPosition: 'center',
        },
      },
    },
  },
})

export const TextColumn = styled(Stack, {
  maxWidth: 'none',
  margin: '16px 16px 32px',
  textAlign: 'center',
  '@bp2': {
    maxWidth: '800px',
    textAlign: 'left',
    margin: '0px 32px 0px 24px',
  },
})

export const FooterCard = styled('div', {
  background: '$tertiary-200',
  borderRadius: '8px',
  border: '1px solid $accent-black',
  zIndex: 1,
  position: 'relative',
  margin: 'auto',
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '345px',

  '@bp2': {
    maxWidth: '790px',
    flexDirection: 'row',
    alignItems: 'center',
  },
})

export const CardShadow = styled('div', {
  width: '100%',
  height: '100%',
  background: '$secondary-500',
  borderRadius: '8px',
  position: 'absolute',
  top: '16px',
  left: '50%',
  transform: 'translateX(calc(-50% + 16px))',
})

export const FooterContainer = styled('div', {
  maxWidth: '361px',
  position: 'relative',
  margin: 'auto',

  '@bp2': {
    maxWidth: '790px',
  },
})
